import React from "react";
import { Button } from "../../atoms/Button/Button";
import { WhatsappLinkInterface } from "../../../features/whatsappLink/domain/interfaces/WhatsappLinkInterface";
import { BsWhatsapp } from "react-icons/bs";

interface WhatsappLinksListProps {
  links: WhatsappLinkInterface[];
}

export const WhatsappLinksList: React.FC<WhatsappLinksListProps> = ({
  links,
}) => {
  return (
    <div
      className={`w-full grid gap-4 ${
        links.length > 1 ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1"
      }`}
    >
      {links.map((link) => (
        <a
          key={link.id}
          href={link.link}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button color="secondary" type="button">
            <div className="flex justify-center items-center gap-2">
              <BsWhatsapp className="text-2xl" />
              {link.name}
            </div>
          </Button>
        </a>
      ))}
    </div>
  );
};
